



































import { mapActions, mapGetters } from 'vuex';

import { AlignEnum, ApiEnum, KpiEnum, RelatedTypeEnum } from '../../../enums';

import { capitalizeSentence } from '../../../filters';

import { DataTableColumn, Pagination } from '../../../models';

import { ANALYTICS_CONSTS } from '../../../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../../../store/config/config.consts';

import DataTable from '../../crud/data-table.component.vue';
import PaginationBar from '../../crud/pagination-bar.component.vue';
import KpiBar from '../../kpi-bar.component.vue';
import Tabs from '../../tabs.component.vue';

export default {
  name: 'related-table',
  components: {
    DataTable,
    KpiBar,
    Tabs,
    PaginationBar
  },
  computed: {
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data,
      selectedId: ANALYTICS_CONSTS.getters.selectedId
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    typeTabs: function (): any[] {
      return Object.values(RelatedTypeEnum).reduce((typeTabs: any[], relatedType: RelatedTypeEnum) => {
        const relatedTypeKpiId: KpiEnum = this.getRelatedTypeKpiId(relatedType);
        const relatedKpiMessage: string = this.messages.kpis[relatedTypeKpiId].valueLabel;
        if (this.kpis.includes(relatedTypeKpiId)) {
          typeTabs.push({
            id: relatedType,
            text: capitalizeSentence(relatedKpiMessage)
          });
        }
        return typeTabs;
      }, []);
    },
    columns: function (): DataTableColumn[] {
      const selectedKpiId: KpiEnum = this.getRelatedTypeKpiId(this.selectedType);
      const selectedKpiMessage: string = this.messages.kpis[selectedKpiId].valueLabel;
      const columns: DataTableColumn[] = [
        {
          id: 'id',
          text: this.messages.productId
        },
        {
          id: 'name',
          text: this.messages.product,
          width: '200%'
        }, {
          id: 'relatedCount',
          text: capitalizeSentence(selectedKpiMessage),
          width: '8rem',
          align: AlignEnum.END
        },
        {
          id: 'relatedPct',
          text: this.messages.volume,
          width: '13rem',
          align: AlignEnum.CENTER
        }
      ];
      return columns;
    },
    relatedData: function (): any[] {
      const selectedIdData = this.data.ids[this.selectedId];
      if (!!selectedIdData && !!selectedIdData.related[this.selectedType]) {
        return selectedIdData.related[this.selectedType].data.items;
      } else {
        return [];
      }
    }
  },
  data: function () {
    return {
      selectedType: undefined,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      },
      itemsPerPageOptions: [10, 50, 100, 200],
      loading: false,
      messages: this.$epb.messages.analytics
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadRelatedData: ANALYTICS_CONSTS.actions.loadRelatedData
    }),
    loadData: async function (resetAll = false): Promise<void> {
      if (resetAll) {
        this.pagination.page = 1;
      }
      this.loading = true;
      try {
        const relatedData = await this.loadRelatedData({
          selectedId: this.selectedId,
          type: this.selectedType,
          pagination: this.pagination
        });
        this.pagination.totalItems = relatedData.data.total;
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading = false;
      }
    },
    getRelatedTypeKpiId: function (relatedType: RelatedTypeEnum): KpiEnum {
      return {
        [RelatedTypeEnum.CLICK]: () => KpiEnum.CLICKS,
        [RelatedTypeEnum.ADD2CART]: () => KpiEnum.ADD2CART
      }[relatedType]();
    },
    getKpiBar: function (dataItem: any) {
      const selectedKpiId = this.getRelatedTypeKpiId(this.selectedType);
      const selectedKpiMessage = this.messages.kpis[selectedKpiId].valueLabel;
      return {
        id: selectedKpiId,
        label: capitalizeSentence(selectedKpiMessage),
        percentage: dataItem.relatedPct
      };
    },
    onPaginationChange: function (pagination: Pagination): void {
      this.pagination = pagination;
      this.loadData();
    }
  },
  created: function () {
    this.selectedType = this.typeTabs[0].id;
  },
  watch: {
    selectedType: function (): void {
      if (!!this.selectedId) {
        this.loadData(true);
      }
    },
    pagination: {
      deep: true,
      handler: function (): void {
        this.$refs.relatedTableContainer.scrollLeft = 0;
      }
    }
  }
};
